


import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, EMPTY } from 'rxjs';
import { tap, map, switchMap, take, catchError, withLatestFrom, filter, concatMap, mergeMap } from 'rxjs/operators';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { get, mergeWith } from 'lodash';

import { getValue } from '@app/shared/utils/feature-utils';
import * as fromStore from '@app/core/store';
import * as fromMaster from '../store/master-create-user-wizard.actions';
import { ActionHandler } from '@app/core/components/actions/action.handler';
import { MessagesService } from '@app/core/services/messages/message.service';
import { UserService } from '@services-api/user.service';
import { environment } from '@env/environment';
const BASE_PATH = environment.basePath;

@Injectable()
export class MasterCreateUserWizardEffects {
  constructor(
    private actions$: Actions,
    private actionHandler: ActionHandler,
    private store: Store<fromStore.State>,
    private message: MessagesService,
    private httpClient: HttpClient,
    private service: UserService,
  ) { }

  nextConfirmStep$ = createEffect(
    (): any =>
      this.actions$.pipe(
        ofType(fromMaster.nextAction, fromMaster.confirmAction),
        map(payload => {
          return fromStore.validateScreenAction({
            id: payload.id + payload.target.screenId,
            ...payload.target
          });
        })
      ),

  );

  checkStep0SuccessValidation$ = createEffect(
    (): any =>
      this.actions$.pipe(
        ofType(fromMaster.checkStep0ValidationAction),
        filter(payload => payload.isValid),
        switchMap(payload => {
          return [
            fromMaster.nextSuccessAction({
              ...payload,
              id: payload.ctx.rootId
            }),
            fromMaster.checkStep1ValidationAction({
              id: payload.ctx.rootId + '-access-profile-screen',
              data: { ...payload.value },
              validate: false,
              isValid: false,
              ignoreCheckStep: true
            })
          ];
        })
      ),

  );

  checkStepFailValidation$ = createEffect(
    (): any =>
      this.actions$.pipe(
        ofType(fromMaster.checkStep0ValidationAction, fromMaster.checkStep1ValidationAction),
        filter(payload => !payload.isValid && !payload.ignoreCheckStep),
        map(payload => {
          return fromMaster.nextFailAction({
            ...payload,
            id: payload.ctx.rootId
          });
        })
      ),

  );


  confirmSuccessValidation$ = createEffect(
    (): any =>
      this.actions$.pipe(
        ofType(fromMaster.checkStep1ValidationAction),
        filter(payload => payload.isValid),
        switchMap(payload => {
          const user = payload.data;
          return this.service.postUsingPOST(user)

            .pipe(
              map(result => fromMaster.confirmSuccessAction({
                ...payload,
                data: { ...result },
                id: payload.ctx.rootId
              })
              ),
              catchError(e =>
                fromMaster.confirmFailAction({
                  ...payload,
                  id: payload.ctx.rootId
                })
              )
            )
        })
      ),

  );

  confirmFailValidation$ = createEffect(
    (): any =>
      this.actions$.pipe(
        ofType(fromMaster.checkStep1ValidationAction),
        filter(payload => !payload.isValid && !payload.ignoreCheckStep),
        map(payload => {
          return fromMaster.confirmFailAction({
            ...payload,
            id: payload.ctx.rootId
          });
        })
      ),

  );


  navigateAfterConfirm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromMaster.confirmSuccessAction),
      map((context: any) => {
        context['path'] = '/master/Visualizar-Usuario';
        context['navigationType'] = 'switch';
        context['feature'] = 'master';
        context['screen'] = 'Visualizar-Usuario';
        context['queryParams'] = { proximooa: undefined };
        return fromStore.navigateBySwitchAction(context);

      })
    ));



}


